import { useReducer } from 'react';
import { FormField, TextInput } from 'grommet';
import { HelpWith } from '@components/basicComponents';
import { HelpWithType } from '@customTypes/enums';
import type { FormFieldsProps } from '@customTypes/types';
import type { ComputeOpsManagementSupportFormFieldsState } from '@customTypes/stateTypes';
import { helpWithOptions } from './ComputeOpsManagementSupportFormOptions';

export const ComputeOpsManagementSupportFormFields = (props: FormFieldsProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: ComputeOpsManagementSupportFormFieldsState, newState: Partial<ComputeOpsManagementSupportFormFieldsState>) => ({
      ...prev,
      ...newState,
    }),
    {
      helpWith: '',
      showSerialNumber: false,
    }
  );

  const helpWithChange = (option: string): void => {
    if (option === state.helpWith) {
      return;
    }

    clearFirstSelectState();
    updateState({ helpWith: option, showSerialNumber: true });
    props.onDetailsChange({ showDetails: true });
  };

  const clearState = (): void => {
    clearFirstSelectState();
    updateState({ helpWith: '' });
  };

  props.onReset && props.onReset(clearState);

  const clearFirstSelectState = (): void => {
    updateState({ showSerialNumber: false });
    props.onDetailsChange({ showDetails: false });
  };

  return (
    <>
      <HelpWith
        selectType={!props.isConsolidated ? HelpWithType.First : HelpWithType.Second}
        options={Object.values(helpWithOptions)}
        onChange={helpWithChange}
      />

      {state.helpWith === helpWithOptions.localGatewayConnectivity &&
        <FormField name="localGatewayId" htmlFor="local-gateway-id" label="Local gateway ID" required>
          <TextInput id="local-gateway-id" name="localGatewayId" placeholder="Local gateway ID" />
        </FormField>
      }

      {state.showSerialNumber &&
        <FormField name="serialNumber" htmlFor="serial-number" label="Serial number" required>
          <TextInput id="serial-number" name="serialNumber" placeholder="Serial number" />
        </FormField>
      }
    </>
  );
};
